import React, { useState } from 'react';
import { Facebook, Instagram, Linkedin, Mail, Phone, X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer id="footer" className="bg-[#0A5E5C] text-white pt-20 pb-10" data-id="element-120">
        <div className="container mx-auto px-4" data-id="element-121">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-122">
            {/* Brand Column */}
            <div className="lg:col-span-1" data-id="element-123">
              <div className="flex items-center gap-2 mb-6" data-id="element-124">
                <div className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center" data-id="element-125">
                  <span className="text-[#D4A843] font-serif font-bold text-lg" data-id="element-126">
                    FG
                  </span>
                </div>
                <span className="text-xl font-serif font-bold" data-id="element-127">
                  Fair Gaming Space
                </span>
              </div>
              <p className="text-white/70 text-sm leading-relaxed mb-6" data-id="element-128">
                Fair Gaming Space захищає права гравців та сприяє розвитку
                чесного ігрового ринку. Приєднуйтесь до нашої спільноти.
              </p>
              <div className="flex gap-4" data-id="element-129">
                <a href="https://www.facebook.com/share/14bkTnc99Km/?mibextid=wwXIfr" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-130">
                  <Facebook size={18} data-id="element-131" />
                </a>
                <a href="https://www.instagram.com/olenavodolazhko?igsh=bHJjNTRjcWwzb2dl" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-132">
                  <Instagram size={18} data-id="element-133" />
                </a>
                <a href="https://www.linkedin.com/in/olena-vodolazhko-372ab576?utm_source=share_via&utm_content=profile&utm_medium=member_ios" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-134">
                  <Linkedin size={18} data-id="element-135" />
                </a>
                <a href="https://t.me/prostirchesnoigry" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-136">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-137">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-138" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div data-id="element-139">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-140">
                Швидкі посилання
              </h3>
              <ul className="space-y-3" data-id="element-141">
                {[{
                name: 'Головна',
                target: 'hero'
              }, {
                name: 'Про нас',
                target: 'founder'
              }, {
                name: 'Активності',
                target: 'activities'
              }, {
                name: 'Новини',
                target: 'news'
              }, {
                name: 'Контакти',
                target: 'footer'
              }].map(item => <li key={item.name} data-id="element-142">
                    <button onClick={() => {
                  const el = document.getElementById(item.target);
                  if (el) {
                    const headerOffset = 80;
                    const elementPosition = el.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({
                      top: elementPosition - headerOffset,
                      behavior: 'smooth'
                    });
                  }
                }} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-143">
                      <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-144" />
                      {item.name}
                    </button>
                  </li>)}
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-145">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-146">
                Інформація
              </h3>
              <ul className="space-y-3" data-id="element-147">
                <li data-id="element-148">
                  <button onClick={() => setActiveModal('privacy')} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-149">
                    <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-150" />
                    Політика конфіденційності
                  </button>
                </li>
                <li data-id="element-151">
                  <button onClick={() => setActiveModal('terms')} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-152">
                    <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-153" />
                    Умови використання
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div data-id="element-154">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-155">
                Контактна інформація
              </h3>
              <ul className="space-y-4" data-id="element-156">
                <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-157">
                  <Mail size={18} className="text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-158" />
                  <span data-id="element-159">fgsukraine@gmail.com</span>
                </li>
                <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-160">
                  <Phone size={18} className="text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-161" />
                  <span data-id="element-162">+38 (067) 403 2026</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/50" data-id="element-163">
            <p data-id="element-164">© 2024 Простір Чесної Гри. Всі права захищені.</p>
            <p data-id="element-165">Розроблено з любов'ю до чесної гри</p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {activeModal === 'privacy' && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-166">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-167" />
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-168">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-169">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-170">
                Політика конфіденційності
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-171">
                <X className="w-5 h-5" data-id="element-172" />
              </button>
            </div>
            <div className="p-6 md:p-8 space-y-6 text-gray-700 leading-relaxed text-sm" data-id="element-173">
              <div className="text-center mb-4" data-id="element-174">
                <h4 className="text-lg font-serif font-bold text-[#0A5E5C]" data-id="element-175">
                  КОМПЛЕКСНА ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ ТА ЗАХИСТУ ДАНИХ
                </h4>
                <p className="text-[#D4A843] font-medium mt-1" data-id="element-176">
                  ГО «Простір чесної гри»
                </p>
                <p className="text-gray-500 text-xs mt-1" data-id="element-177">
                  Редакція: 18 February 2026
                </p>
              </div>

              <div className="space-y-5" data-id="element-178">
                <div data-id="element-179">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-180">
                    1. Загальні положення
                  </h5>
                  <p data-id="element-181">
                    Ця Політика визначає порядок обробки та захисту персональних
                    даних ГО «Простір чесної гри» (FAIR Gaming Space).
                    Організація діє відповідно до Закону України «Про захист
                    персональних даних», а також застосовує принципи GDPR та UK
                    GDPR у разі взаємодії з резидентами ЄС або Великої Британії.
                  </p>
                </div>
                <div data-id="element-182">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-183">
                    2. Принципи обробки даних
                  </h5>
                  <p data-id="element-184">
                    Обробка здійснюється на принципах законності, прозорості,
                    обмеження мети, мінімізації даних, точності, обмеження
                    строків зберігання та забезпечення цілісності й
                    конфіденційності.
                  </p>
                </div>
                <div data-id="element-185">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-186">
                    3. Категорії даних
                  </h5>
                  <p data-id="element-187">
                    Ім'я, email, організація, IP-адреса, технічні дані,
                    відповіді на дослідницькі анкети, а також знеособлені або
                    псевдонімізовані дані.
                  </p>
                </div>
                <div data-id="element-188">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-189">
                    4. Правові підстави (GDPR Art. 6, 9)
                  </h5>
                  <p data-id="element-190">
                    Згода суб'єкта даних; законний інтерес; виконання статутних
                    завдань; виконання юридичних зобов'язань. Спеціальні
                    категорії даних обробляються виключно на підставі явної
                    згоди та з належними гарантіями.
                  </p>
                </div>
                <div data-id="element-191">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-192">
                    5. Міжнародна передача даних
                  </h5>
                  <p data-id="element-193">
                    У разі передачі даних за межі України або ЄС застосовуються
                    Standard Contractual Clauses (SCC) або інші передбачені
                    законом механізми захисту.
                  </p>
                </div>
                <div data-id="element-194">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-195">
                    6. Data Processing Agreement (DPA)
                  </h5>
                  <p data-id="element-196">
                    У разі залучення підрядників (хостинг, email-сервіси, CRM)
                    укладаються договори про обробку даних (DPA), що
                    встановлюють обов'язки процесора щодо безпеки та
                    конфіденційності.
                  </p>
                </div>
                <div data-id="element-197">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-198">
                    7. Cookies Policy
                  </h5>
                  <p data-id="element-199">
                    Сайт використовує обов'язкові, аналітичні та функціональні
                    cookies. Користувач може керувати згодою через банер або
                    налаштування браузера.
                  </p>
                </div>
                <div data-id="element-200">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-201">
                    8. Data Breach Response Procedure
                  </h5>
                  <p data-id="element-202">
                    У разі порушення безпеки даних Організація здійснює
                    внутрішнє розслідування, вживає заходів для мінімізації
                    ризиків та повідомляє компетентні органи та суб'єктів даних
                    у строки, передбачені законодавством.
                  </p>
                </div>
                <div data-id="element-203">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-204">
                    9. Призначення DPO
                  </h5>
                  <p data-id="element-205">
                    Організація може призначити відповідальну особу з питань
                    захисту даних (Data Protection Officer), яка контролює
                    відповідність законодавству та приймає звернення суб'єктів
                    даних.
                  </p>
                </div>
                <div data-id="element-206">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-207">
                    10. Права суб'єктів даних
                  </h5>
                  <p data-id="element-208">
                    Право на доступ, виправлення, видалення, обмеження обробки,
                    перенесення даних, відкликання згоди та подання скарги до
                    наглядового органу.
                  </p>
                </div>
                <div data-id="element-209">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-210">
                    11. UK & US Compliance Block
                  </h5>
                  <p data-id="element-211">
                    У разі співпраці з UK або US грантодавцями Організація
                    дотримується вимог UK GDPR, UK Data Protection Act, а також
                    забезпечує відповідність міжнародним стандартам безпеки
                    даних та антикорупційного законодавства (UK Bribery Act,
                    FCPA).
                  </p>
                </div>
                <div data-id="element-212">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-213">
                    12. Строки зберігання
                  </h5>
                  <p data-id="element-214">
                    Дані зберігаються не довше, ніж це необхідно для досягнення
                    мети обробки та виконання законодавчих або грантових вимог.
                  </p>
                </div>
                <div data-id="element-215">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-216">
                    13. Оновлення політики
                  </h5>
                  <p data-id="element-217">
                    Актуальна версія Політики завжди публікується на офіційному
                    вебсайті.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {/* Terms of Use Modal */}
      {activeModal === 'terms' && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-218">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-219" />
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-220">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-221">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-222">
                Умови використання
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-223">
                <X className="w-5 h-5" data-id="element-224" />
              </button>
            </div>
            <div className="p-6 md:p-8 space-y-6 text-gray-700 leading-relaxed text-sm" data-id="element-225">
              <div className="text-center mb-4" data-id="element-226">
                <h4 className="text-lg font-serif font-bold text-[#0A5E5C]" data-id="element-227">
                  УМОВИ ВИКОРИСТАННЯ
                </h4>
                <p className="text-[#D4A843] font-medium mt-1" data-id="element-228">
                  ГО «Простір чесної гри» / FAIR Gaming Space
                </p>
                <p className="text-gray-500 text-xs mt-1" data-id="element-229">
                  Редакція: 18 February 2026
                </p>
              </div>

              <div className="space-y-5" data-id="element-230">
                <div data-id="element-231">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-232">
                    1. Загальні положення
                  </h5>
                  <p data-id="element-233">
                    Ці Розширені Умови використання регулюють доступ та
                    використання вебсайту Громадської організації «Простір
                    чесної гри» (FAIR Gaming Space) (далі — Організація).
                    Використовуючи Сайт, Користувач підтверджує повну згоду з
                    цими Умовами. Організація має право змінювати Умови без
                    попереднього повідомлення.
                  </p>
                </div>
                <div data-id="element-234">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-235">
                    2. Незалежність та неафілійованість
                  </h5>
                  <p data-id="element-236">
                    Організація є незалежною неприбутковою структурою. Вона не
                    здійснює гральну діяльність, не афілійована з операторами
                    азартних ігор, не отримує affiliate-винагород та не просуває
                    комерційні послуги операторів.
                  </p>
                </div>
                <div data-id="element-237">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-238">
                    3. Research Integrity Clause
                  </h5>
                  <p data-id="element-239">
                    Усі дослідження проводяться незалежно, відповідно до
                    принципів академічної доброчесності, методологічної
                    прозорості та добровільної участі. Донори не впливають на
                    результати досліджень.
                  </p>
                </div>
                <div data-id="element-240">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-241">
                    4. Інформаційний характер матеріалів
                  </h5>
                  <p data-id="element-242">
                    Матеріали Сайту мають інформаційний, аналітичний та освітній
                    характер. Вони не є юридичною, медичною або фінансовою
                    консультацією. Організація не несе відповідальності за
                    рішення, прийняті Користувачем на підставі матеріалів Сайту.
                  </p>
                </div>
                <div data-id="element-243">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-244">
                    5. Реєстрація та участь у дослідженнях
                  </h5>
                  <p data-id="element-245">
                    Користувач може реєструватися для отримання новин або участі
                    в дослідженнях. Участь у дослідженнях є добровільною та
                    базується на принципі інформованої згоди.
                  </p>
                </div>
                <div data-id="element-246">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-247">
                    6. Донати та фінансова прозорість
                  </h5>
                  <p data-id="element-248">
                    Добровільні внески є безповоротною благодійною допомогою.
                    Організація забезпечує прозору фінансову звітність та може
                    проходити незалежний аудит.
                  </p>
                </div>
                <div data-id="element-249">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-250">
                    7. Антикорупційні та санкційні положення
                  </h5>
                  <p data-id="element-251">
                    Організація дотримується законодавства України, міжнародних
                    антикорупційних стандартів, UK Bribery Act та FCPA (у разі
                    міжнародного фінансування). Не приймаються кошти від
                    підсанкційних осіб або структур.
                  </p>
                </div>
                <div data-id="element-252">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-253">
                    8. Інтелектуальна власність
                  </h5>
                  <p data-id="element-254">
                    Усі матеріали Сайту захищені законодавством про
                    інтелектуальну власність. Комерційне використання без
                    письмового дозволу заборонене.
                  </p>
                </div>
                <div data-id="element-255">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-256">
                    9. Захист персональних даних
                  </h5>
                  <p data-id="element-257">
                    Обробка персональних даних здійснюється відповідно до Закону
                    України «Про захист персональних даних» та принципів GDPR (у
                    разі міжнародної взаємодії).
                  </p>
                </div>
                <div data-id="element-258">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-259">
                    10. Обмеження відповідальності
                  </h5>
                  <p data-id="element-260">
                    Організація не гарантує безперебійну роботу Сайту та не несе
                    відповідальності за технічні перебої або дії третіх осіб.
                  </p>
                </div>
                <div data-id="element-261">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-262">
                    11. Застосовне право
                  </h5>
                  <p data-id="element-263">До цих Умов застосовується законодавство України.</p>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </>;
}